<template>
  <div class="documents__list">
    <vs-table stripe :data="documents" search>
      <template slot="header">
        <h3>Documents ({{ documents.length }})</h3>
      </template>
      <template slot="thead">
        <vs-th>File</vs-th>
        <vs-th sort-key="desc">Description</vs-th>
        <vs-th sort-key="created">Created</vs-th>
        <vs-th>Author</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
          <vs-td :data="getFile(tr)">
            <span class="file-name">{{ getFile(tr) ? getFile(tr).name : '—' }}</span>
          </vs-td>
          <vs-td :data="tr.desc" class="desc-cell">{{ tr.desc || '—' }}</vs-td>
          <vs-td :data="tr.created">
            <span v-if="tr.created">{{
              $moment(tr.created * 1000).format('DD.MM.YYYY HH:mm')
            }}</span>
          </vs-td>
          <vs-td :data="tr.owner && tr.owner.nickname">
            {{ tr.owner && tr.owner.nickname ? tr.owner.nickname : '—' }}
          </vs-td>
          <vs-td :data="tr.id">
            <vs-button
              :data-id="tr.id"
              radius
              color="dark"
              icon="download"
              type="flat"
              title="Download"
              @click="downloadHandler(tr)"
            ></vs-button>
            <vs-button
              v-if="isPdf(tr)"
              :data-id="tr.id"
              radius
              color="dark"
              icon="visibility"
              type="flat"
              title="View"
              @click="viewHandler(tr)"
            ></vs-button>
            <vs-button
              v-if="$can('manage', 'document')"
              :data-id="tr.id"
              radius
              color="dark"
              icon="delete"
              type="flat"
              title="Delete"
              @click="deleteHandler(tr.id)"
            ></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      selectedId: null,
      proxy: process.env.VUE_APP_PROXY,
    }
  },
  computed: {
    ...mapState({
      documents: state => state.documents.documents,
    }),
  },
  methods: {
    getFile: function(tr) {
      return tr.files && tr.files.length ? tr.files[0] : null
    },
    isPdf: function(tr) {
      const file = this.getFile(tr)
      return file ? this.getFileExt(file.name).toLowerCase() === 'pdf' : false
    },
    getFileExt: function(filename) {
      return filename.split('.').pop()
    },
    downloadHandler: function(tr) {
      const file = this.getFile(tr)
      if (!file) return
      fetch(this.proxy + file.file_path)
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob)
          var link = document.createElement('a')
          link.setAttribute('download', file.name)
          link.setAttribute('hidden', true)
          link.href = url
          document.body.appendChild(link)
          link.click()
          link.remove()
          URL.revokeObjectURL(url)
        })
    },
    viewHandler: function(tr) {
      const file = this.getFile(tr)
      if (!file) return
      window.open(this.proxy + file.file_path, '_blank')
    },
    deleteHandler: function(id) {
      this.selectedId = id
      this.openAlert()
    },
    openAlert: function() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Delete document',
        text: 'Are you sure you want to delete the document?',
        accept: this.acceptAlert,
      })
    },
    acceptAlert: function() {
      this.$emit('deleteDocument', this.selectedId)
      this.selectedId = null
    },
  },
}
</script>

<style lang="scss">
.documents__list {
  .file-name {
    word-break: break-all;
    max-width: 12rem;
    display: inline-block;
  }
  .desc-cell {
    max-width: 20rem;
  }
}
</style>
